<template>
  <div class="w800">
    <div class="header-wrapper mb20">
      <b class="fs16">设置订阅入口</b>
      <a-button type="primary" @click="handleAdd">新增</a-button>
    </div>
    <a-table :columns="columns" :dataSource="data" :pagination="false">
      <template #type="{ record }">
        <div>
          {{ typeOptions.find(item => item.value === record.type).label }}
        </div>
      </template>
      <template #statusPc="{ record }">
        <a-switch
          v-model:checked="record.statusPc"
          checked-children="启用"
          un-checked-children="禁用"
        ></a-switch>
      </template>
      <template #statusM="{ record }">
        <a-switch
          v-model:checked="record.statusM"
          checked-children="启用"
          un-checked-children="禁用"
        ></a-switch>
      </template>
      <template #operate="{ record, index }">
        <a @click="handleEdit(record, index)">编辑</a>
        <a-popconfirm
          class="ml10"
          title="是否确认删除?"
          ok-text="是"
          cancel-text="否"
          @confirm="handleDelete(index)"
        >
          <a class="ml10">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <a-modal
      :title="title"
      v-model:visible="visible"
      okText="确定"
      cancelText="取消"
      @ok="handleOk"
    >
      <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="侧边栏入口" required>
          <a-select
            placeholder="请选择"
            :options="[
              { label: '订阅弹窗', value: 1 },
              { label: 'APP引流', value: 2 },
              { label: 'LiveChat', value: 3 },
              { label: '返回顶部', value: 4 }
            ]"
            v-model:value="formState.type"
          ></a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-checkbox v-model:checked="formState.statusPc">PC端开启</a-checkbox>
          <a-checkbox v-model:checked="formState.statusM">M端开启</a-checkbox>
        </a-form-item>
        <a-form-item
          label="不展示的路由"
          v-if="formState.type !== 1 && formState.type !== null"
        >
          <a-input
            placeholder="多个以;分割"
            v-model:value="formState.filterUrl"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="icon"
          v-if="formState.type !== 1 && formState.type !== null"
          required
        >
          <a-upload
            accept="image/*"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :maxCount="1"
            :customRequest="uploadImg"
          >
            <img
              v-if="formState.iconUrl"
              width="100"
              height="100"
              style="object-fit: contain;"
              class="img"
              :src="formState.iconUrl"
              alt="avatar"
            />

            <div v-else>
              <loading-outlined v-if="loading"></loading-outlined>
              <plus-outlined v-else></plus-outlined>
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { reactive, toRefs, inject } from 'vue'
export default {
  setup() {
    const state = reactive({
      columns: [
        {
          title: '侧边入口',
          dataIndex: 'type', // 假设数据对象中有名为 'sidebarEntrance' 的属性
          key: 'type',
          slots: { customRender: 'type' }
        },
        {
          title: 'PC端开启订阅',
          dataIndex: 'statusPc', // 假设数据对象中有名为 'pcSubscription' 的属性
          key: 'statusPc',
          slots: { customRender: 'statusPc' }
        },
        {
          title: 'M端开启订阅',
          dataIndex: 'statusM', // 假设数据对象中有名为 'mSubscription' 的属性
          key: 'statusM',
          slots: { customRender: 'statusM' }
        },
        {
          title: '操作',
          dataIndex: 'operate',
          key: 'operate',
          slots: { customRender: 'operate' }
        }
      ]
    })
    return {
      ...toRefs(inject('initState')),
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
